module.exports = __webpack_public_path__ + "media/images/right_show_sidebar/upload-a76fd4de524f8cfbe8831a2383c3fc33.png";